/*
 * VatomInc. Copyright (c) 2022, all rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in the root directory of this source tree.
 */
import { getType } from 'mime'

import logger from '../../logger'

export function encodeJsonToBase64(str: any) {
  return Buffer.from(JSON.stringify(str)).toString('base64')
}

export function getBrowserInfo() {
  const ua = navigator.userAgent
  let os = 'unknown'
  let version = 'unknown'
  let uaIndex = 0

  // determine OS
  if (ua.match(/iPad/i) || ua.match(/iPhone/i)) {
    os = 'iOS'
    uaIndex = ua.indexOf('OS ')
  } else if (ua.match(/Android/i)) {
    os = 'Android'
    uaIndex = ua.indexOf('Android ')
  }

  // determine version
  if (os === 'iOS' && uaIndex > -1) {
    version = ua.substr(uaIndex + 3, 3).replace('_', '.')
  } else if (os === 'Android' && uaIndex > -1) {
    os = ua.substr(uaIndex + 8, 3)
  }

  return {
    version,
    os,
    isMobile: os !== null
  }
}

export function generateSmsLink(link: string) {
  const browserInfo = getBrowserInfo()
  let replaceBody = ''

  switch (browserInfo.os) {
    case 'iOS':
      if (parseFloat(browserInfo.version || '0') <= 8) {
        replaceBody = ';'
      } else {
        replaceBody = '&'
      }
      break
    default:
      break
  }
  if (replaceBody) {
    return link.replace(/\?body=/, replaceBody + 'body=')
  }
  return link
}

export function toTitleCase(str: string | undefined) {
  if (!str) return str

  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  })
}

export const getFirstTwoNames = (name: string): string => {
  return name?.split(' ').splice(0, 2).join(' ')
}

export const toFixed = (n: number, fixed: number): number =>
  ~~(Math.pow(10, fixed) * n) / Math.pow(10, fixed)

export const ignoreErrors = (f: () => any) => {
  try {
    return f()
  } catch (e) {
    return undefined
  }
}

// Function to extract url parameters from a url
export const getUrlParameter = (name: string, url = window.location.href) =>
  decodeURIComponent(
    (new RegExp(`[?|&]${name}=([^&;]+?)(&|#|;|$)`).exec(url) || ['', ''])[1].replace(/\+/g, '%20')
  ) || null

export const allImgSupported = [
  'image/gif',
  'image/jpeg',
  'image/png',
  'image/tiff',
  'image/vnd.microsoft.icon',
  'image/x-icon',
  'image/vnd.djvu',
  'image/svg+xml',
  'image/webp'
]

export const allVideosSupported = [
  'video/mpeg',
  'video/mp4',
  'video/quicktime',
  'video/x-ms-wmv',
  'video/x-msvideo',
  'video/x-flv',
  'video/webm'
]

export const allModelsSupported = [
  'model/gltf-binary',
  // TODO: make mores test
  //  'image/webp',
  'application/json'
]

export const validateUrl = (str: string) => {
  let url
  try {
    url = new URL(str)
  } catch (_) {
    return false
  }
  return url.protocol === 'http:' || url.protocol === 'https:'
}

export const getMimeType = async (url: string) => {
  if (!url) return null

  let mime: string | null = getType(url)

  try {
    if (!mime) {
      const nft_heads = await fetch(url, {
        method: 'HEAD',
        mode: 'no-cors'
      })
      mime = nft_heads.headers.get('content-type')
    }
    return mime
  } catch (error) {
    logger.error('nft', error, 'this is the ', url)
    return null
  }
}

export const isSupported = (type: string | null) => {
  return type
    ? allImgSupported.includes(type) ||
        allModelsSupported.includes(type) ||
        allVideosSupported.includes(type)
    : false
}

export function getIdFromIdOrUri(idOrUri: string) {
  if (idOrUri.includes('varius')) {
    return idOrUri.split(':')[2]
  }
  return idOrUri
}
